import React, { useCallback, useEffect, useRef, useState } from "react";
import ListPageHeader from "../../utilities/ListPageHeader";
import FusePageCarded from "@fuse/core/FusePageCarded/FusePageCarded";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import Progress from "./Progress";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";

const useStyles = makeStyles((theme) => ({
  root: {
    "& ul.question": {
      counterReset: "my-awesome-counter",
      listStyle: "none",
      
      "& li": {
        padding: "15px 0 15px 33px",
        position: "relative",
        counterIncrement: "my-awesome-counter",
        borderBottom: `1px solid rgba(241,245,249,.12)`,
      },
      "& li::before": {
        content: "counter(my-awesome-counter)",
        color: "#fff",
        position: "absolute",
        left: "0",
        lineHeight: "22px",
        width: "22px",
        height: "22px",
        background: "#EAAA05",
        borderRadius: "50%",
        textAlign: "center",
        fontSize: '10px',
      },
      "& .label": {
        padding: "4px 15px",
        textTransform: "uppercase",
        borderRadius: "15px",
      },
      "& .yes": {
        background: "#37C734",
      },
      "& .no": {
        background: "#C74634",
      },
      "& .comment": {
        paddingTop: "5px",
      },
    },
    "& .heading": {
        background: `${theme.palette.common.black}`,
        borderRadius: '4px',
        marginTop: '10px',
        marginBottom: '10px',
        padding: '5px 15px',
    },
  },
}));

const url = `${process.env.REACT_APP_DESIGN_STUDIO_API_KEY_URL}${oAuthServiceConfig.dsTaskAssignments}`;

export default function ShowroomQuestionnaire(props) {
  const { id } = useParams()
  const classes = useStyles(props);
  const navigate = useNavigate();
  const [navigated, setNavigated] = useState(false);
  const [error, setError] = useState();
  const [showPaginationDropdown, setShowPaginationDropdown] = useState(false);
  const [showRoomQuestion, setShowRoomQuestion] = useState();
  
  const loadQuestionnaire = async () => {
    try {
      const list = await OAuthService.getList(`${url}/${id}`);
      let questionnaire = list.data;
      setShowRoomQuestion(questionnaire);
    } catch (error) {
      setError(error.message);
      console.log(error);
    }
  };

  const handleShowRoomQuestionNext = async () => {
    const tempData = {...showRoomQuestion, isDsLifeCyclePassForNextState: showRoomQuestion?.dsLifeCycle === "REQUEST_BRIEF", isDsStatusPassForNextState: false};
    await OAuthService.putData(`${url}/${id}`, tempData)
    navigate("/design-studio/request-review/" + id);
  };

  useEffect(() => {
      loadQuestionnaire()
  }, [])

  const handleBack = () => {
    navigate('/design-studio/request-list');
  };
  
  return (
    <>
      <FusePageCarded
        classes={{
          content: "flex",
          header: "min-h-72 h-72 sm:h-136 sm:min-h-136",
        }}
        header={
          <ListPageHeader
            componentName="Showroom Questionnaire"
            pageName={`Request #${id}`}
            showPaginationDropdown={showPaginationDropdown}
            handleShowRoomQuestionNext={handleShowRoomQuestionNext}
            handleBack={handleBack}
          />
        }
        content={
          <>
            <div className={clsx(classes.root, "px-24 md:px-32")}>
            <Progress currentStep={1} category={showRoomQuestion?.designStudioCategory} />
            <Box className="heading"><Typography variant="h6">Showroom questionnaire</Typography></Box>
              <ul className="question">
                {showRoomQuestion?.dsQuestionnaires.map((i, index) => {
                return (
                  <li>
                      {i.question} {" "} {i.answer && <span className={`label ${i.answer === 'Yes' ? 'yes' : 'no'}`}>{i.answer}</span>}
                      {i.comment && <div className="comment">
                        <strong>Comment :</strong> {i.comment}
                      </div>}
                    </li>
                  )
                })}
              </ul>
              <div className="pt-16 mt-10">
                <Button variant="contained" color="warning" size="large" onClick={handleShowRoomQuestionNext}>
                  Next
                </Button>
              </div>
            </div>
          </>
        }
        innerScroll
      />
    </>
  );
}
